module.exports = __webpack_public_path__ + "img/hero.935e7c72.png";